import { Box } from '@mui/material';
import React from 'react';
import { useStyles } from './Wrapper.styles';
export default function Wrapper(props) {
    const classes = useStyles();
    return React.createElement(Box, { sx: classes.root }, props.children);
}
